import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3260_63422)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.6127 3.32802C23.7822 3.62168 23.7822 3.98347 23.6127 4.27712L13.1134 22.4625C12.4217 23.6604 10.6341 23.4562 10.2305 22.1331L7.35789 12.7165L0.63549 5.51468C-0.308324 4.50356 0.408673 2.85348 1.79183 2.85348L22.7907 2.85348C23.1298 2.85348 23.4431 3.03437 23.6127 3.32802ZM9.32948 12.674L11.8336 20.8827L20.1971 6.39675L9.32948 12.674ZM19.25 4.75167L8.38041 11.0301L2.51992 4.75167L19.25 4.75167Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63422",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
